import { createSelector } from '@reduxjs/toolkit';
// import { pushExploreLinkClicked } from 'src/routes/SeoApp/utils/gtmEvents';

export const getLinked = (state) => state.get('linked')?.toJS();

// Linked months:
export const getLinkedMonths = createSelector(
  getLinked,
  (linked) => linked.linked_months,
);

// Linked operators:
export const getLinkedOperators = createSelector(
  getLinked,
  (linked) => linked.linked_operators,
);

// Linked departures:
export const getLinkedDepartures = createSelector(
  getLinked,
  (linked) => linked.linked_departures,
);

// Linked recommended:
export const getLinkedRecommended = createSelector(
  getLinked,
  (linked) => linked.linked_recommended,
);

// Linked countries:
export const getLinkedCountries = createSelector(
  getLinked,
  (linked) => linked.linked_countries,
);
export const getLinkedCountryList = createSelector(
  getLinked,
  (linked) => linked.linked_country_list,
);
export const getLinkedCountryListWithAnalytic = createSelector(
  getLinkedCountryList,
  (linked_country_list) => linked_country_list,
  // ?.map((item) => ({
  //   ...item,
  //   onClick: () => {
  //     pushExploreLinkClicked({
  //       explore_link_clicked_params: { type: 'country' },
  //     });
  //   },
  // })),
);
export const getLinkedCountryListTitle = createSelector(
  getLinked,
  (linked) => linked.linked_country_list_title,
);

// Linked resorts:
export const getLinkedDestionationRegionList = createSelector(
  getLinked,
  (linked) => linked.linked_destination_regions,
);
export const getLinkedMetaregionsList = createSelector(
  getLinked,
  (linked) => linked.linked_metaregions,
);
export const getLinkedModifiers = createSelector(
  getLinked,
  (linked) => linked.linked_modifiers,
);
export const getResortListTitle = createSelector(
  getLinked,
  (linked) => linked.linked_resort_list_title,
);
